module.exports = __webpack_public_path__ + "static/fipcbluefloral1-6d688029b44a14fc92b5c98bdac216d9.jpeg";